import { CommissionsCalculator } from "./commissions-calculator";
import { GoalSIPCalculator } from "./goal-sip-calculator";
import { LumpsumCalculator } from "./lumpsum-calculator";
import { SIPReturnsCalculator } from "./sip-returns-calculator";
import { SWPCalculator } from "./swp-calculator";
import { ExpressionCalculator } from "./expression-calculator";

export const Calculators = {
  GoalSIPCalculator,
  LumpsumCalculator,
  CommissionsCalculator,
  SIPReturnsCalculator,
  SWPCalculator,
  ExpressionCalculator,
};
